<script setup lang="ts">
import { ref } from 'vue'
import type { ClientHit } from '../models/search.model'

import ExpandPanel from '@/shared/components/panel/ExpandPanel.vue'

interface Props {
  loading: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()

const isExpanded = ref<boolean>(false)

const model = defineModel<ClientHit>()
</script>

<template>
  <ExpandPanel
    v-if="model"
    v-model="isExpanded"
    :label="$t('message.searchResult', { count: model ? model.items.length : 0 })"
    class="px-3 pb-3"
  >
    <div v-if="model" class="max-h-90 overflow-y-auto px-3" v-bind="$attrs">
      <table class="w-full">
        <thead class="font-medium text-xs text-gray-700">
          <tr>
            <th class="text-start pb-1">{{ $t('glossary.box') }}</th>
            <th class="text-start pb-1">{{ $t('glossary.city') }}</th>
            <th class="text-start pb-1">{{ $t('glossary.zipCode') }}</th>
            <th class="text-center pb-1">{{ $t('glossary.hit') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="box in model.items"
            :key="box.mBoxId"
            class="overflow-hidden text-sm border-t border-gray-100"
          >
            <td class="max-w-40 py-1.5 truncate">
              {{ box.label }}
            </td>
            <td class="max-w-20 truncate">
              {{ box.address }}
            </td>
            <td class="max-w-20 truncate">
              {{ box.zipCode }}
            </td>
            <td class="max-w-20 truncate text-center">
              <span v-if="box.hitWordAreaType" class="bg-success text-white px-2 p-1">
                {{ box.hitWordAreaType }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ExpandPanel>
</template>
